/**
 * Handles creating object which holds all possible keys for a user's progressive profile data.
 *
 * @constant userProfileData
 * @type (ResponseBody)
 *
 * @author Jaskiran Chhokar
 */

import { ResponseBody } from 'globalTypes';

const userProfileData: ResponseBody = {
    // Hardcoding this values in this object for testing purposes, will remove dummy data later
    originatorData: {
        applicationCatalogueId: 'required-test-data',
        country: 'required-test-data',
        transitNumber: '',
        locationId: '',
        locationType: '',
        channel: 'required-test-data',
        employeeUserId: '',
        employeeUserName: '',
    },
    // if encrypted = true, it wont validate for secured.data to be a JSON string, since it will be taking the encrypted string
    SECURED: {
        encrypted: false,
        data: JSON.stringify({
            firstName: '',
            lastName: '',
            middleName: '',
            fullName: '',
            dateOfBirth: '',
            emailAddress: '',
            primaryPhoneNum: '',
            secondaryPhoneNum: '',
            addressLineOne: '',
            addressLineTwo: '',
            additionalContactInfo: '',
            gender: '',
        }),
    },
    universalIds: {
        uID: 'required-test-data',
        darId: '',
        adobeAnalyticsFallbackId: '',
        adobeAnalyticsVisitorId: '',
        adobeExperienceCloudId: '',
        adobeExperienceVisitorCloudId: '',
        abobeEcidId: '',
        googleClickId: '',
        salesforcePersonalizationId1: '',
        salesforcePersonalizationId2: '',
        facebookBrowserId: '',
        applicationId: '',
    },
    browserInfo: {
        ipAddress: '',
        userAgent: '',
        geoLocation: '',
        browserType: '',
        language: '',
        refDomain: '',
        domain: '',
        cookieExpiryInDays: 365,
    },
    nonPiiData: {
        title: '',
        city: '',
        state: '',
        country: '',
        psCode: '',
    },
    consent: {
        functionalConsentOptIn: '',
        performanceConsentOptIn: '',
        marketingConsentOptIn: '',
        optInValues: '',
        consentTimestamp: '',
    },
};

export default userProfileData;
